module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('x-header', {
    staticStyle: {
      "background-color": "#2b3033"
    },
    attrs: {
      "left-options": {
        backText: ""
      }
    }
  }, [_vm._v("\n    评价工单\n  ")]), _vm._v(" "), _c('group', {
    staticStyle: {
      "margin": "0 0.1rem",
      "border-radius": "0.3rem"
    },
    attrs: {
      "label-width": "5em"
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center",
      "margin": ".8rem 0"
    }
  }, [_c('rater', {
    model: {
      value: (_vm.data),
      callback: function($$v) {
        _vm.data = $$v
      },
      expression: "data"
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.text))])], 1), _vm._v(" "), _c('x-textarea', {
    attrs: {
      "placeholder": "请填写您的评价",
      "max": 200,
      "show-counter": false,
      "height": 100,
      "rows": 8,
      "cols": 30
    },
    model: {
      value: (_vm.reply),
      callback: function($$v) {
        _vm.reply = $$v
      },
      expression: "reply"
    }
  })], 1), _vm._v(" "), _c('x-button', {
    staticStyle: {
      "background-color": "#00aaff",
      "color": "#fff",
      "margin-top": "1rem",
      "width": "97%"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.Pingjia($event)
      }
    }
  }, [_vm._v("提交")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c848838","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/console/workorassess.vue
// module id = QLiU
// module chunks = 1